import React from 'react';
import { Copy, Label } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookRadioWrapper } from 'src/components/CookbookRadioWrapper/CookbookRadioWrapper';
import { CorpSubscriptionFundingType } from 'src/types/Corp';
import { useMembershipPayerOptionsControl } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/MembershipPayerOptionsControl/hooks/useMembershipPayerOptionsControl';

export interface MembershipPayerOptionsControlProps {
  name: string;
  id: string;
  disabledCorpFunding: boolean;
  disabled: boolean;
}

export const warningTextMessage =
  'Client cannot be invoiced for Grubhub+ when they receive multiple invoices';

export function MembershipPayerOptionsControl({
  name,
  id,
  disabled,
  disabledCorpFunding,
}: MembershipPayerOptionsControlProps): JSX.Element {
  const { control } = useFormContext();
  const { isCorpFundingDisabled, isEmployeeFundingDisabled } =
    useMembershipPayerOptionsControl(name, disabled, disabledCorpFunding);

  return (
    <>
      <Label aria-label="Membership options" inputSize="medium">
        Membership paid by
      </Label>
      <>
        <CookbookRadioWrapper
          name={name}
          id={`${id}${CorpSubscriptionFundingType.CORP}`}
          disabled={isCorpFundingDisabled}
          control={control}
          label="Client"
          value={CorpSubscriptionFundingType.CORP}
        />
        {disabledCorpFunding && (
          <Copy variant="caption">{warningTextMessage}</Copy>
        )}
        <CookbookRadioWrapper
          name={name}
          id={`${id}${CorpSubscriptionFundingType.EMPLOYEE}`}
          disabled={isEmployeeFundingDisabled}
          control={control}
          label="Employee"
          value={CorpSubscriptionFundingType.EMPLOYEE}
        />
      </>
    </>
  );
}
